import { IDENTITY_PROVIDER } from './lib/identity.interfaces';
import { RijksregisterService } from './be-rrn/rijksregister.service';

export function provideIdentityManagers() {
  return [
    { provide: IDENTITY_PROVIDER, useClass: RijksregisterService, multi: true },
  ];
}
